import { render, staticRenderFns } from "./ReceivableAccounts.vue?vue&type=template&id=462bc801"
import script from "./ReceivableAccounts.vue?vue&type=script&lang=js"
export * from "./ReceivableAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports